module.exports = __webpack_public_path__ + "img/dialog.100092c4.svg";